module.exports = __webpack_public_path__ + "img/u56.50fe2f28.jpg";